import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

const SvgComponent = props => (
  <Svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <Path
      fill={props.color}
      d="M11.727 5.64C10.745 4.79 9.218 4 7.964 4 4.964 4 3 7.279 3 9.95 3 14.868 12 21 12 21s9-6.071 9-11.05C21 7.279 19.036 4 16.036 4c-1.036 0-2.29.546-3.272 1.275l1.472 1.76-1.963 1.7 2.782 2.915L12 15.293l1.527-3.46-2.89-2.915 2.072-1.882s-.49-.79-.982-1.397z"
      fillRule="nonzero"
    />
  </Svg>
);

export default SvgComponent;
